import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Form, Button, Badge } from 'react-bootstrap';
import LoadingSpinner from './LoadingSpinner';
import { useHttpClient } from '../shared/http-hook';

import { useSearchParams } from "react-router-dom";
import { hashString } from 'react-hash-string';

import axios from 'axios';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateAccountWelcome = props => {
    const { sendRequest } = useHttpClient();

    const [step, setStep] = useState(1);
    const [maxStep, setMaxStep] = useState(2)
    const [email, setEmail] = useState(aff_sub4);
    const [years, setYears] = useState();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);

    const [toastError, setToastError] = useState(false)

    const [userInfo, setUserInfo] = useState();

    const username = Math.random().toString(36).substr(2, 9)

    const getInfo = async () => {
        try {
            const response = await sendRequest('https://geolocation-db.com/json/');
            setUserInfo(response)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getInfo()
    }, []);

    function openInNewTab(href) {
        Object.assign(document.createElement('a'), {
          target: '_blank',
          rel: 'noopener noreferrer',
          href: href,
        }).click();
    }

    // aditional
    const createMailWizz = async () => {
        try {
          const response = await sendRequest(
            'https://gorillamediallc.com/bbgfeedserver/api/createmailwizz',
            'POST',
            JSON.stringify({
                username: username,
                email: email,
                years: years,
                country_code: userInfo ? userInfo.country_code : null,
                aff_sub2: aff_sub2,
                AFFID: aff_sub5
            }),
            {
              'Content-Type': 'application/json'
            }
          );            
          console.log(response)

        } catch (err){
            console.log(err);
        }
    }

    const createDa = async () => {
        try {
            const response = await sendRequest(
              'https://gorillamediallc.com/bbgfeedserver/api/createda',
              'POST',
              JSON.stringify({
                  username: username,
                  email: email,
                  ip: userInfo.IPv4,
                  aff: transaction_id,
                  aff_sub2: aff_sub2
              }),
              {
                'Content-Type': 'application/json'
              }
            );            

            const formatdata = response.data.split("|");
            const url = formatdata[3];
            
            if(url.startsWith('https://' || url !== undefined)){
                window.location.href = 'http://bangbase.app';
                openInNewTab(url)
            } else {
                createTrawle()
            }
  
          } catch (err){
              console.log(err);
          }
    }

    const createMirelia = async () => {
        try {
            const response = await sendRequest(
              'https://gorillamediallc.com/bbgfeedserver/api/createmirelia',
              'POST',
              JSON.stringify({
                  email: email,
                  ip: userInfo.IPv4,
                  aff: transaction_id
              }),
              {
                'Content-Type': 'application/json'
              }
            );            
            
            const url = response.responsedata.url;
            
            if(url.startsWith('https://' || url !== undefined)){
                window.location.href = 'http://bangbase.app';
                openInNewTab(url)
            } else {
                createDa()
            }
  
          } catch (err){
              console.log(err);
          }
    }

    const createTrawle = async () => {
        try {
            const response = await sendRequest(
              'https://gorillamediallc.com/bbgfeedserver/api/createtrawle',
              'POST',
              JSON.stringify({
                  username: username,
                  email: email,
                  ip: userInfo.IPv4,
                  aff: transaction_id,
                  aff_sub2: aff_sub2
              }),
              {
                'Content-Type': 'application/json'
              }
            );          
            
            const url = response.data.login_url;

            if(url.startsWith('https://' || url !== undefined)){
                window.location.href = 'http://bangbase.app';
                openInNewTab(url)
            } else {
                createPure()
            }

          } catch (err){
              console.log(err);
          }
    }

    function randomGenerator() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      
        for (var i = 0; i < 10; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
      
        return text.toLowerCase();
    }

    var randomstring = randomGenerator();
    var randomusername = randomGenerator();
    const createPure = async () => {
        try {
            const response = await sendRequest(
                'https://gorillamediallc.com/bbgfeedserver/api/createpure',
                'POST',
                JSON.stringify({
                    uname: randomusername,
                    email: email,
                    password: randomstring,
                    ip_address: userInfo.IPv4,
                    city: userInfo.city,
                    state: userInfo.state,
                    aff: transaction_id,
                    aff_sub2: aff_sub2
                }),
                {
                  'Content-Type': 'application/json'
                }
              );          
              
              if(response.data !== "\"OK\""){
                createMirelia()
              }
        } catch (err) {
            console.log(err)
        }
    }

    // const createFlirt = async () => {
    //     try {
    //         const response = await sendRequest(
    //           'https://gorillamediallc.com/bbgfeedserver/api/createflirt',
    //           'POST',
    //           JSON.stringify({
    //               email: email,
    //               ip: userInfo.IPv4
    //           }),
    //           {
    //             'Content-Type': 'application/json'
    //           }
    //         );            
            
    //         console.log(response)
  
    //       } catch (err){
    //           console.log(err);
    //       }       
    // }

    /*const createTm = async () => {
        try {
            const response = await sendRequest(
              'https://gorillamediallc.com/bbgfeedserver/api/createtm',
              'POST',
              JSON.stringify({
                  username: username,
                  email: email,
                  ip: userInfo.IPv4
              }),
              {
                'Content-Type': 'application/json'
              }
            );            
            
            let stringify = JSON.stringify(response)
            let finall = JSON.parse(stringify)
            
            if(finall.callstatus === true){
                alert('success trawle open tab')
                return;
            } else {
                createTrawle()
            }
  
          } catch (err){
              console.log(err);
          }
    }
    */    


    const [searchParams, setSearchParams] = useSearchParams();
    const transaction_id = searchParams.get("aff_sub");
    const aff_sub1 = searchParams.get("aff_sub1");
    const aff_sub2 = searchParams.get("aff_sub2");
    const aff_sub3 = searchParams.get("aff_sub3");
    const aff_sub4 = searchParams.get("aff_sub4");
    const aff_sub5 = searchParams.get("aff_sub5");

    const saveFileUsers = async (data) => {
        try {
          await sendRequest(
            'https://gorillamediallc.com/bbgfeedserver/api/savefileusers',
            'POST',
            JSON.stringify(data),
            {
              'Content-Type': 'application/json'
            }
          );
    
        } catch (err) {}
    }

    const [usersDB, setUsersDB] = useState([])
    const checkDB = async (email) => {
        const response = await sendRequest(
            'https://gorillamediallc.com/bbgfeedserver/stored/data/usersdb.json',
            'GET',
            null,
            {
              'Content-Type': 'application/json'
            }        
        )

        setUsersDB(response)
        const result = response.find((user) => user.email === email)

        let checked;
        if(result) {
            checked = true;
        } else {
            checked = false;

            const formObject = {
                email: email
            }
            
            setUsersDB((prev) => [...prev, formObject])
        }

        return checked
    }

    const emailAPI = async (email) => {
        try {
            const response = await sendRequest(
              'https://gorillamediallc.com/bbgfeedserver/api/checkemailapi',
              'POST',
              JSON.stringify({
                  email: email
              }),
              {
                'Content-Type': 'application/json'
              }
            );


            return response.dataresponse;      
          } catch (err) {
              console.log(err)
          }
    }

    const submitForm = async () => {

        if(step !== maxStep){
            setError('You must finish all steps!')
            return;          
        }

        setLoading(true)

        try {
            const user = {
                username: username,
                email: email,
                years: years
            }

            localStorage.setItem('user', JSON.stringify(user));
            props.onCreate(user);
            setStep('finished')

            // postback
            if(transaction_id){
                const hash = hashString(email);
                localStorage.setItem('transaction_id', transaction_id)
                await axios.get(`https://www.gorillatrk1.com/?nid=1737&transaction_id=${transaction_id}&adv1=${hash}&sub2=${aff_sub2}&sub3=${aff_sub3}`)    
            }

            localStorage.setItem('aff_sub1', aff_sub1)
            localStorage.setItem('aff_sub2', aff_sub2)
            localStorage.setItem('aff_sub3', aff_sub3)
            localStorage.setItem('aff_sub4', aff_sub4)
            localStorage.setItem('aff_sub5', aff_sub5)

            createMailWizz()
            createMirelia()
            
            saveFileUsers(usersDB)

        } catch (err) {
            setError(err)
        } finally {
            setTimeout(() => {
                window.location.href = "/"
            }, 5000);
        }
    }

    function checkEmail(str) {
        var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return pattern.test(str);
    }

    const continueStep = async (e) => {
        e.preventDefault();

        setToastError(null)
        
        if((step === 1 && !years) || (step === 1 && years < 18)){
            setError('Age are required! Must be older than 18 years!')
            return;      
        } 
        // step email
        if(step === 1 && checkEmail(email) === false){
                setError('Email is not valid!')
                return;      
        } 

        if(step === 1 && email){
            const emailapi = await emailAPI(email);

            if(emailapi && emailapi.valid === false && emailapi.recent_abuse === true && emailapi.deliverability === "low"){
                setError('Email did not pass the request!')
                window.open('https://www.gorillatrk1.com/cmp/2D2DH/RF39C/', '_blank');
                return; 
            }
        }

        const emailDB = await checkDB(email);
        if(step === 1 && emailDB === true){
            setError('Email is already in use!')
            return;             
        }

        if(step < maxStep || !error){
            setLoading(true)

            setTimeout(function(){
                    setStep(step + 1);
                    setError('')
                    setLoading(false)
            }, 2000);
        }

    }

    useEffect(() => {
        
        if(step === 2) {
            setLoading(true)
    
            setTimeout(() => {
                submitForm()
            }, 2000);
        }

    }, [step]);


    // useEffect(() => {

    //     const interval = setInterval(async () => {
    //         if(toastError === false){
    //             const response = await sendRequest('./data/users.json');
    //             const result = response.sort(function() { 
    //                 return .5 - Math.random() 
    //             }).slice(0, 1);
        
    //             toast.success("Someone new wants to meet you! Check her out!", {
    //                 icon: ({theme, type}) =>  <img className='img-fluid' style={{ maxHeight: "100px" }} src={result[0]?.image}/>, 
    //                 onClick: () => {
    //                     setToastError(true)
    //                     callToast()
    //                 }
    //             });
    //         }

    //     }, 5000);

    //     return () => clearInterval(interval);

    // }, [toastError]);

    // const callToast = () => {   
    //     const email_input = document.querySelector('#email_input')
    //     email_input.focus()

    //     toast.error('Enter age and email to check her out!', {
    //                 position: "top-center",
    //                 autoClose: false,
    //                 hideProgressBar: false,
    //                 closeOnClick: false,
    //                 pauseOnHover: false,
    //                 draggable: false,
    //                 onClick: () => {
    //                     email_input.focus()
    //                 }
    //     })

    // }
    
    return (
        <React.Fragment>

            <ToastContainer
                className="toaster-container customtoas_width"
                position="top-center"
                autoClose={2000}
                closeOnClick={false}
                closeButton={false}
                hideProgressBar={true}
                newestOnTop={true}
                rtl={false}
                draggable={false}
                pauseOnFocusLoss 
                limit={1}               
            />

            {step !== 'finished' ? (
            <center>
            <Badge bg="dark">
                <span>{step}</span> / <span>{maxStep}</span>
            </Badge>
            </center>
            ) : null}

            <Form onSubmit={submitForm}>
            {loading && <LoadingSpinner asOverlay />}
            {step === 1 ? (
                <>
                <div className="form-step">
                    <h2>Welcome to BangBase!</h2> <hr />
                    
                    <Form.Group className="mb-3" controlId="formBasicAge">
                        <Form.Label>Age:</Form.Label>
                        <Form.Control type="text" name="age" maxLength="2" autoComplete="off" defaultValue={years ? years : ''} placeholder="Enter age" onChange={(e) => setYears(parseInt(e.target.value))} />
                    </Form.Group>                                  

                    <Form.Group className="mb-3" controlId="email_input">
                        <Form.Label>Email:</Form.Label>
                        <Form.Control type="email" name="email" autoComplete="off" defaultValue={aff_sub4 ? aff_sub4 : email} placeholder="Enter email" onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>   
                    <div className="info-form-imp">                              
                    <small>By proceeding I certify I am 18 years or older, agree to the <a href="/tos" target="_blank">TOS</a>, <a href="/privacypolicy" target="_blank">Privacy Policy</a> , sign up for newsletters and agree to receive messages.</small>     
                    </div> 
                    
                </div> 
                </>
            ) : step === 2 ? (
                <>
                  <div className="form-step mb-2">
                    <h2>FINISHED</h2> <hr />

                    <div className='finished-form'>
                        <h1><i className="fa-solid fa-clipboard-check"></i></h1>
                        <p>Profile created successfully!</p>
                    </div> 

                </div> 
                </>    
            ) : null}


            {error ? (
                        <>
                        <div className="ctm-error"> <i className="fa-solid fa-triangle-exclamation"></i> {error} </div>
                        </>
            ) : ''}
                            
            {
                typeof step === 'number' ? (
                    <>
                    {step === maxStep && typeof step == 'number' && step ? '' : <Button type="button" variant="dark" size="lg" className="form-btnright" onClick={continueStep}> Join for Free </Button> }            
                    </>
                ) : ''
            }
            </Form>
        </React.Fragment>
    )
}

export default CreateAccountWelcome;